import {
  Globe2, ClipboardList, Search, Handshake, Ship, BarChart3,
  Package, Truck, Route, LineChart, Network, FileCheck,
} from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

const ICONS = [
  Globe2, ClipboardList, Search, Handshake, Ship, BarChart3,
  Package, Truck, Route, LineChart, Network, FileCheck,
];

export const Services = () => {
  const { t } = useLang();
  return (
  <section id="services" data-testid="services-section" className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <Eyebrow>{t.services.eyebrow}</Eyebrow>
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <h2 className="text-3xl md:text-4xl tracking-tight font-bold text-[#F4F6F8] max-w-xl">
            {t.services.title}
          </h2>
          <p className="text-base text-[#94A3B8] max-w-sm">
            {t.services.sub}
          </p>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#1E293B] border border-[#1E293B]">
        {t.services.list.map((s, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={i} delay={(i % 3) * 0.06} y={24}>
              <div
                data-testid={`service-${i + 1}`}
                className="group bg-midnight p-8 h-full hover:bg-surface2 transition-colors duration-300"
              >
                <div className="flex items-start justify-between mb-8">
                  <Icon className="w-6 h-6 text-gold transition-transform duration-300 group-hover:scale-110" />
                  <span className="font-display text-sm text-[#94A3B8]/50">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <h3 className="text-lg font-semibold text-[#F4F6F8] mb-2">{s.title}</h3>
                <p className="text-sm text-[#94A3B8] leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
  );
};
